"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessCapability = exports.getStandardDeviationOfSample = exports.getStandardDeviation = exports.getMean = exports.getSum = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const checks_1 = require("./checks");
/** Calculates the sum of an array of numbers */
const getSum = (n) => n.reduce((total, next) => total + next, 0);
exports.getSum = getSum;
/** Calculates the mean (average) of an array of numbers */
const getMean = (n) => (n.length ? (0, exports.getSum)(n) / n.length : 0);
exports.getMean = getMean;
const getSampleMean = (n) => n.length > 1 ? (0, exports.getSum)(n) / (n.length - 1) : NaN;
/** Calculates the population standard deviation of an array of numbers. Equivalent to Excel `STDEV.P`. */
const getStandardDeviation = (array) => {
    if (array.length < 2) {
        return 0;
    }
    const avg = (0, exports.getMean)(array);
    return Math.sqrt((0, exports.getMean)(array.map((x) => Math.pow(x - avg, 2))));
};
exports.getStandardDeviation = getStandardDeviation;
/** Calculates the sample standard deviation of an array of numbers. Equivalent to Excel `STDEV.S` or the deprecated `STDEV`. */
const getStandardDeviationOfSample = (array) => {
    if (array.length < 2) {
        return 0;
    }
    const avg = (0, exports.getMean)(array);
    return Math.sqrt(getSampleMean(array.map((x) => Math.pow(x - avg, 2))));
};
exports.getStandardDeviationOfSample = getStandardDeviationOfSample;
const getProcessCapability = (
/** Array of measurement deviations */
deviations, 
/** Upper tolerance (if the measurement has absolute tolerances, convert them to relative) */
upperTol, 
/** Lower tolerance (if the measurement has absolute tolerances, convert them to relative) */
lowerTol) => {
    deviations = deviations.filter(checks_1.isNumber);
    if (deviations.length < 2 || !(0, checks_1.isNumber)(upperTol) || !(0, checks_1.isNumber)(lowerTol))
        return {
            meanDeviation: undefined,
            standardDeviation: undefined,
            pp: undefined,
            ppk: undefined,
        };
    const meanDeviation = (0, exports.getMean)(deviations);
    const standardDeviation = (0, exports.getStandardDeviationOfSample)(deviations);
    const standardDeviationP = (0, exports.getStandardDeviation)(deviations);
    const pp = (upperTol - lowerTol) / (6 * standardDeviation);
    const ppk = Math.min(meanDeviation - lowerTol, upperTol - meanDeviation) /
        (3 * standardDeviation);
    return {
        /** Mean (average) of deviations */
        meanDeviation,
        /** Sample standard deviation (equivalent to Excel STDEV) */
        standardDeviation,
        /** Population standard deviation (equivalent to Excel STDEV.P) */
        standardDeviationP,
        /** Pp (Process performance) */
        pp,
        /** Ppk (Process performance, centering) */
        ppk,
    };
};
exports.getProcessCapability = getProcessCapability;
//# sourceMappingURL=processCapability.js.map